module.exports = __webpack_public_path__ + "static/img/S-303-OAK.c3510a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/S-303-OAK.png
// module id = negn
// module chunks = 0